export const turnConstants = {
    SUCCESS: 'TURN_SUCCESS',
    SUBSIDIARIES: 'TURN_SUBSIDIARIES',
    SELECTEDSUBSIDIARY: 'TURN_SELECTEDSUBSIDIARY',
    PRACTICAS: 'TURN_PRACTICAS',
    PRACTICASELEGIDAS: 'TURN_PRACTICASELEGIDAS',
    ERROR: 'TURN_ERROR',
    FETCHING: 'TURN_FETCHING'
};
